import { create } from 'zustand'

// Hedge-chain hover linkage for trade cards. Kept separate from useTradeStore on
// purpose: TradeCardList subscribes to the whole trade store and keys cards by
// uuid_v4(), so routing hover state through it would remount every card on hover.
interface ChainHoverState {
  hoveredRootId: string | null
  setHoveredRootId: (rootId: string | null) => void
}

export const useChainHoverStore = create<ChainHoverState>((set) => ({
  hoveredRootId: null,
  setHoveredRootId: (rootId) => { set({ hoveredRootId: rootId }) },
}))
